const Footer = () => {
    return (
        <div className="flex fixed bottom-0 h-5 bg-black w-screen text-white justify-center items-center p-2 md:h-10 md:text-2xl">
            <a href="tel:7709211611">(770)-921-1611</a>
        </div>
    )
}

export default Footer;